import IconArrowForward1 from "@/icons/IconArrowForward1";
import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { AgentStatusLabel, StatusType } from "@velaro/velaro-component-lib";

interface Props {
  status: StatusType;
  onStatusChange(status: StatusType): void;
}

export function UserStatusInput({ status, onStatusChange }: Props) {
  const [show, setShow] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleToggle = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setPosition({ top: rect.top, left: rect.right + 10 });
    }
    setShow((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (buttonRef.current && !buttonRef.current.contains(e.target as Node)) {
        setShow(false);
      }
    };

    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <div className="relative w-full">
      <button
        ref={buttonRef}
        type="button"
        className="flex items-center cursor-pointer hover:bg-slate-gray-200 rounded-lg"
        onClick={() => {
          handleToggle();
        }}
      >
        <AgentStatusLabel status={status} />
        <IconArrowForward1 className="w-5 h-5" />
      </button>
      {show &&
        ReactDOM.createPortal(
          <div
            style={{
              top: position.top,
              left: position.left
            }}
            className="absolute w-40 p-2 bg-white rounded-lg shadow text-sm z-50"
          >
            <AgentStatusLabel
              status="Available"
              onClick={() => {
                onStatusChange("Available");
              }}
            />
            <AgentStatusLabel
              status="Away"
              onClick={() => {
                onStatusChange("Away");
              }}
            />
            <AgentStatusLabel
              status="Offline"
              onClick={() => {
                onStatusChange("Offline");
              }}
            />
          </div>,
          document.body
        )}
    </div>
  );
}
